import { NgOptimizedImage } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ProductPriceComponent } from '@scalefast/components/product';
import { TranslateProductFieldPipe } from 'src/app/shared/pipes/translate-product-field.pipe';

@Component({
  selector: 'app-product-bundle',
  styleUrls: ['./product-bundle.component.scss'],
  templateUrl: './product-bundle.component.html',
  standalone: true,
  imports: [RouterLink, ProductPriceComponent, NgOptimizedImage, TranslateProductFieldPipe],
})
export class AppProductBundleComponent {
  @Input() productBundle: Array<any> = [];
  @Input() missingProductImageUrl: string = '';

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  translateProductField(prodDescription: any[], field: string): string {
    const description = prodDescription.find((item) => item.lang.toLowerCase() === this.locale);
    return description ? description[field] : prodDescription[0][field];
  }
}
